import {
  getAdminDashboardApi,
  getCompleteDataApi,
  getEmployeeDashboardApi,
  getEmployeeReviewSummary,
  getProjectApiLeads,
  getLastThreePeriods,
  getEmployeeByPeriods,
  getProjectApiLeadsByPeriods,
  getAdminDashboardApiByPeriods,
  getManagerDashboardApi,
  getProjectApi
} from '../../../api/rest/dashboardApi';

export const getEmployeeDashboard = () => async (dispatch) => {
  const result = await getEmployeeDashboardApi();
  if (result.data !== null && result.data[0]) {
    return result.data[0];
  }
  return null;
};

export const getEmployeeDashboardPeriod = (periods) => async (dispatch) => {
  const result = await getEmployeeByPeriods(periods);
  if (result && result.data !== null && result.data[0]) {
    return result.data[0];
  }
  return null;
};

export const getManagerDashboard = (projectId) => async (dispatch) => {
  const result = await getManagerDashboardApi(projectId);
  if (result.data !== null && result.data[0]) {
    return result.data[0];
  }
  return null;
};

export const getManagerDashboardByPeriods = (periods, projectId) => async (dispatch) => {
  const result = await getProjectApiLeadsByPeriods(periods, projectId);
  if (result !== null && result.data) {
    return result.data[0];
  }
  return null;
};


export const getAdminDashboard = (period) => async (dispatch) => {
  const result = await getAdminDashboardApi(period);
  if (result.data !== null && result.data[0]) {
    console.log(result.data[0]);
    return result;
  }
  return null;
};

export const getAdminDashboardByPeriods = (period) => async (dispatch) => {
  const result = await getAdminDashboardApiByPeriods(period);
  if (result.data !== null && result.data[0]) {
    return result.data[0];
  }
  return null;
};

export const getAllGraphicData = () => async (dispatch) => {
  const result = await getCompleteDataApi();
  if (result !== null && result.data) {
    return result.data;
  }
  return null;
};

export const getListProject = () => async (dispatch) => {
  const result = await getProjectApi();
  if (result !== null && result.data) {
    return result.data;
  }
  return null;
};

export const getListProjectLead = () => async (dispatch) => {
  const result = await getProjectApiLeads();
  if (result !== null && result.data) {
    return result.data;
  }
  return null;
};

export const getReviewSummary = (currentPeriodId, projectId, params) => async (dispatch) => {
  const result = await getEmployeeReviewSummary(currentPeriodId, projectId, params);
  if (result.data !== null && result.data) {
    const {data = []} = result.data;
    return data;
  }
  return null;
};

export const getLastThreePeriodsData = () => async (dispatch) => {
  const result = await getLastThreePeriods();
  if (result.data !== null && result.data) {
    return result.data;
  }
  return null;
};